import {combineReducers} from 'redux';
import destroy from 'src/modules/taskForm/destroy/taskFormDestroyReducers';
import form from 'src/modules/taskForm/form/taskFormFormReducers';
import list from 'src/modules/taskForm/list/taskFormListReducers';

export default combineReducers({
  list,
  form,
  destroy,
});
